import { t } from "@connect/i18n";

export const DOB_FORMAT = "MM/DD/YYYY";

const DOB_PATTERN = /^(\d{2})\/(\d{2})\/(\d{4})$/;
const MIN_AGE_YEARS = 18;
const MAX_AGE_YEARS = 99;

function completedYears(from: Date, to: Date): number {
  const years = to.getFullYear() - from.getFullYear();
  const hadAnniversary =
    to.getMonth() > from.getMonth() ||
    (to.getMonth() === from.getMonth() && to.getDate() >= from.getDate());
  return hadAnniversary ? years : years - 1;
}

export function validateDateOfBirth(value: string, now: Date = new Date()): string | null {
  const match = DOB_PATTERN.exec(value);
  if (!match) {
    return t("challenge.limitUpgrade.validation.dateOfBirthFormat", { format: DOB_FORMAT });
  }

  const month = Number(match[1]);
  const day = Number(match[2]);
  const year = Number(match[3]);
  const dateOfBirth = new Date(year, month - 1, day);
  const isRealDate =
    dateOfBirth.getFullYear() === year &&
    dateOfBirth.getMonth() === month - 1 &&
    dateOfBirth.getDate() === day;
  if (!isRealDate) {
    return t("challenge.limitUpgrade.validation.dateOfBirthInvalid");
  }

  if (dateOfBirth > now) {
    return t("challenge.limitUpgrade.validation.dateOfBirthFuture");
  }

  const age = completedYears(dateOfBirth, now);
  if (age < MIN_AGE_YEARS) {
    return t("challenge.limitUpgrade.validation.dateOfBirthTooYoung", { age: MIN_AGE_YEARS });
  }
  if (age > MAX_AGE_YEARS) {
    return t("challenge.limitUpgrade.validation.dateOfBirthTooOld", { years: MAX_AGE_YEARS });
  }
  return null;
}

export function validateDateOfBirthWhileTyping(value: string, now?: Date): string | null {
  return DOB_PATTERN.test(value) ? validateDateOfBirth(value, now) : null;
}

export function validateSsnLastFour(value: string): string | null {
  return /^\d{4}$/.test(value) ? null : t("challenge.limitUpgrade.validation.ssnLastFour");
}
